// src/pages/pedidos/ModalDetalhePedido.js
import { formatarVariacoes } from '../../utils/VariacaoUtils';
import React, { useRef, useState } from "react";
import { formatCurrency } from "../../utils/numberUtils";
import "./ModalDetalhePedido.css"; // Mantenha a importação do CSS
import { getPedidoByIdService } from "../../services/pedidos/PedidoService.js";
import ModalContainer from "../../components/modalForm/ModalContainer";
import ModalHeader from "../../components/modalForm/ModalHeader";
import ModalBody from "../../components/modalForm/ModalBody";
import ModalFooter from "../../components/modalForm/ModalFooter";
import CadPedido from "./CadPedido";
import { usePedido } from "../../contexts/pedidos/PedidoContext";
import { MdLocalPrintshop } from "react-icons/md";
import { VscGitPullRequestGoToChanges } from "react-icons/vsc";
import { usePrinter } from "../../contexts/geral/PrinterContext";
import { useConfigModulo } from "../../contexts/administrativo/ConfigModuloContext";
import { getNumeroPedido } from "../../utils/pedidoUtils";
import { getStatusPedidoDescricao } from "../../models/pedidos/StatusPedido";


const ModalDetalhePedido = ({ isOpen, onClose, pedidoComanda=false }) => {
  
  //const [updateId, setUpdateId] = useState(false);
  const [isModalCadOpen, setIsModalCadOpen] = useState(false);
  const [isImprimindoPedido, setIsImprimindoPedido] = useState(false);
  const isImprimindoPedidoRef = useRef(false);
  const { pedidoSel, setPedidoSel } = usePedido();  
  const { printPedidoPDFById } = usePrinter();  
  const { configModuloSel } = useConfigModulo();

  // ✅ return condicional SEMPRE depois dos hooks
  if (!isOpen || !pedidoSel) {
    return null;
  }


  const valorItens = pedidoSel.valorItens;
  const valorDesconto = pedidoSel.valorDesconto;
  const valorEntrega = pedidoSel.taxaEntrega;  
  const valorTotal = pedidoSel.valorTotal;
  const valorCashBack = pedidoSel.valorCashBack;
  const trocoPara = pedidoSel.trocoPara;
  const numeroPedido = getNumeroPedido(pedidoSel, configModuloSel);


  const handleAlterarPedidoClose = async () => {
    const result = await getPedidoByIdService(pedidoSel.id);
    setPedidoSel(result);
    setIsModalCadOpen(false);
    onClose();
  };

  const handleImprimirPedido = async () => {
    if (isImprimindoPedidoRef.current || pedidoSel.id === 0) {
      return;
    }

    isImprimindoPedidoRef.current = true;
    setIsImprimindoPedido(true);

    try {
      //const pedido = await getPedidoById(pedidoSel.id);
      await printPedidoPDFById(pedidoSel.id);
    } catch (error) {
      console.error('Erro ao buscar detalhes do pedido:', error);
    } finally {
      isImprimindoPedidoRef.current = false;
      setIsImprimindoPedido(false);
    }
  };

  return (

    <ModalContainer show={isOpen} largura='700px'>
      <ModalHeader>
        <h5 className="modal-title">Detalhes do Pedido Nº {numeroPedido}</h5>

        <button
          type="button"
          className="btn-close"
          aria-label="Close"
          onClick={onClose}
        />

      </ModalHeader>

      <ModalBody>
        <div className="itens-body">
          <p>
            <strong>Cliente:</strong>{" "}
            {pedidoSel.cliente ? pedidoSel.cliente.nome : pedidoSel.nomeCliente}
          </p>          
          
          {/* Se não tiver forma de pagamento é COMANDA mostra o status na direita */}
          {!pedidoSel.formaPag && (<p><strong>Status: </strong>{getStatusPedidoDescricao(pedidoSel.statusPedido)}</p>)}

          {pedidoSel.telefoneCliente && (<p><strong>Telefone: </strong>{pedidoSel.telefoneCliente}</p>)}
            
        </div>
        <div className="itens-body">        
        <p>
          <strong>Forma de Pagamento:</strong>{" "}
          {pedidoSel.formaPag
            ? pedidoSel.formaPag.descricao
            : "N/A"}
        </p>
        <p>
            <strong>Previsão:</strong>{" "}
            {pedidoSel.horaPrevisao}                    
          </p>
        </div>
        <div className="itens-body">
        <p>
          <strong>Modo de Entrega:</strong>{" "}
          {pedidoSel.tipoEntrega ? pedidoSel.tipoEntrega.descricao : "N/A"}
        </p>
        {pedidoSel.cliente && (
          <p>
          <strong>Telefone:</strong>{" "}
          {pedidoSel.cliente.telefone}   
        </p>
        )}
            
        </div>
        {pedidoSel.tipoEntrega.descricao === "Delivery" && (
          <p>
            {pedidoSel.cliente ? (
              <>
                <strong>Endereço: </strong> Logradouro: {pedidoSel.endereco.logradouro} Bairro: {pedidoSel.endereco.bairro} Complemento: {pedidoSel.endereco.complemento}
              </>
            ) : (
              <>
                <strong>Endereço: </strong> 
                {pedidoSel.enderecoCliente}
              </>
            )}
          </p>
        )}

        {pedidoSel.observacao?.trim() && (
          <p>
            <strong>Observação: </strong>
            {pedidoSel.observacao}
          </p>
        )}

        <h5>Produtos:</h5>
        <table className="table">
          <thead>
            <tr>
              <th>ID</th>
              <th>Produto</th>
              <th className="direita">Qtde</th>
              <th className="direita">Valor</th>
            </tr>
          </thead>
          <tbody>
            {pedidoSel.pedidoItens.map((item) => {
              // Agrupando itens de conjunto por nomeConjunto
              const conjuntosPorNome = {};
              item.pedidoItemConjuntos?.forEach((cj) => {
                if (!conjuntosPorNome[cj.nomeConjunto]) {
                  conjuntosPorNome[cj.nomeConjunto] = [];
                }
                conjuntosPorNome[cj.nomeConjunto].push(cj);
              });

              return (
                <React.Fragment key={item.id}>
                  <tr>
                    <td>{item.produtoId}</td>
                    <td>
                      {item.produto.descricao}{" "}
                      <strong>{item.apresentacao && ' - ' + item.apresentacao+' '}</strong>

                      <strong>{formatarVariacoes(item)}</strong>
                    </td>
                    <td className="direita">{item.qtde}</td>
                    <td style={{width:'100px'}} className="direita">{formatCurrency(item.valorTotal)}</td>
                  </tr>

                  {item.observacao && (
                    <tr className="observacao-row">
                      <td colSpan="3" className="observacao">
                        Obs.: {item.observacao}
                      </td>
                    </tr>
                  )}

                  {/* NOVO BLOCO: Conjuntos agrupados por nomeConjunto */}
                  {Object.keys(conjuntosPorNome).length > 0 && (
                    <tr className="observacao-row">
                      <td colSpan="3" className="observacao">
                        {Object.entries(conjuntosPorNome).map(([nomeConjunto, itens]) => (
                          <div key={nomeConjunto} className="conjuntoItem">
                            <strong>{nomeConjunto}:</strong>{" "}
                            {itens.map((cj, index) => {
                              const nomeItem = cj.descricao || 'Item';
                              const qtdItens = cj.qtdItens || 0;
                              const valorExtra = cj.valorAdicional > 0 ? ` (${formatCurrency(cj.valorAdicional)})` : '';
                              const separador = index < itens.length - 1 ? ', ' : '';
                              return (
                                <span key={cj.id}>
                                  {nomeItem}({qtdItens}x){valorExtra}{separador}
                                </span>
                              );
                            })}
                          </div>
                        ))}
                      </td>
                    </tr>
                  )}

                  {item.pedidoItemAdicionais?.length > 0 && (
                    <tr className="observacao-row">
                      <td colSpan="3" className="observacao">
                        <strong>Adicionais:</strong>
                        {item.pedidoItemAdicionais.map((ad) => (
                          <div key={ad.id} className="adicionalItem">
                            • {ad.adicional?.descricao || 'Adicional'} ({formatCurrency(ad.valor)})
                          </div>
                        ))}
                      </td>
                    </tr>
                  )}                  
                </React.Fragment>
              );
            })}

          </tbody>
        </table>
        <div className="valores-direita">
          {((parseFloat(valorDesconto) || 0) > 0 || (parseFloat(valorEntrega) || 0) > 0) && (
            <p><strong>Valor Itens: </strong>{formatCurrency(valorItens)}</p>
          )}

          {(parseFloat(valorDesconto) || 0) > 0 && (
            <p><strong>Desconto: </strong>- {formatCurrency(valorDesconto)}</p>                                                               
          )}

          {(parseFloat(valorEntrega) || 0) > 0 && (
            <p><strong>Taxa Entrega: </strong>{formatCurrency(valorEntrega)}</p>                                                               
          )}

          <p>
            <strong>Valor Total: </strong>
            {formatCurrency(valorTotal)}
          </p>          
          {(parseFloat(valorCashBack) || 0) > 0 && (
            <p>
              <strong>CashBack: </strong>
              - {formatCurrency(valorCashBack)}
            </p>
          )}
          {typeof trocoPara === 'number' && trocoPara > 0 && (            
            <p>
              <strong>Troco para: </strong>
              {formatCurrency(trocoPara)}
            </p>
          )}
        </div>

      </ModalBody>
      <ModalFooter>

        {/* <button className="btn btn-secondary">
            Enviar Pedido <BsWhatsapp />
        </button>  */}

        <button className="btn btn-secondary" onClick={handleImprimirPedido} disabled={isImprimindoPedido}>
          Imprimir Pedido<MdLocalPrintshop />
        </button>


        <button
          className="btn btn-primary"
          onClick={() =>setIsModalCadOpen(true)}
        >
          Alterar Pedido <VscGitPullRequestGoToChanges />
        </button>

        {/* <button
          type="button"
          className="btn btn-success"
          onClick={handleAlteraStatus}
        >
          {getButtonLabel(getStatusPedidoDescricao(pedidoSel.statusPedido))}
        </button>             */}
      </ModalFooter>


      <CadPedido
        isOpen={isModalCadOpen}             
        onClose={handleAlterarPedidoClose}       
        pedidoComanda={pedidoComanda}
      /> 
    </ModalContainer>
  );
};



export default ModalDetalhePedido;
